<template>
  <v-container fluid v-resize="onResize">
    <v-data-table
        dense
        :headers="getColumns"
        :items="itemList"
        item-key="id"
        class="elevation-1"
        :options.sync="options"
        :server-items-length="totalRecords"
        @update:options="updateOptions"
        :loading="loading"
        :footer-props="{
            'items-per-page-options': [20, 50, 100, 250]
          }"
        :height="windowSize.y - subtractHeight"
        fixed-header
        :item-class="itemRowBackground"
    >
      <template v-slot:top>
        <v-toolbar ref="RefListTop" height="128" v-if="userId === null">
          <v-container fluid>
            <v-row class="mt-3">
              <v-spacer></v-spacer>
              <TimeTrackerNewDialogTime :user-id="userId" :event-start-date="date" event="working"
                                        color="green lighten-1"></TimeTrackerNewDialogTime>
              <TimeTrackerNewDialogTime :user-id="userId" :event-start-date="date" event="work_kug"
                                        color="green lighten-1"></TimeTrackerNewDialogTime>
              <TimeTrackerNewDialogTime :user-id="userId" :event-start-date="date"
                                        event="time_correction"></TimeTrackerNewDialogTime>
              <TimeTrackerNewDialogTime :user-id="userId" :event-start-date="date"
                                        event="time_add"></TimeTrackerNewDialogTime>
              <TimeTrackerNewDialogRange :user-id="userId" :event-start-date="date"
                                         event="holiday"></TimeTrackerNewDialogRange>
              <TimeTrackerNewDialogRange :user-id="userId" :event-start-date="date"
                                         event="holiday_extra"></TimeTrackerNewDialogRange>
              <TimeTrackerNewDialogRange :user-id="userId" :event-start-date="date"
                                         event="sick"></TimeTrackerNewDialogRange>
              <TimeTrackerNewDialogRange :user-id="userId" :event-start-date="date"
                                         event="sick_with_child"></TimeTrackerNewDialogRange>
              <TimeTrackerNewDialogRange :user-id="userId" :event-start-date="date"
                                         event="sick_kug"></TimeTrackerNewDialogRange>
            </v-row>
            <v-row class="mt-10">
                <v-text-field
                    v-model="searchTerm"
                    label="Search user, employee, department"
                    clearable
                    @input="onUpdateSearchTerm"
                ></v-text-field>
              <v-spacer></v-spacer>
                <v-select
                  v-model="filterEvents"
                  :items="eventsList"
                  :menu-props="{ maxHeight: '400' }"
                  label="Event"
                  multiple
                  chips
                  deletable-chips
                  clearable
                  class="mt-n2"
                  @change="onUpdateFilters"
              ></v-select>
              <v-spacer></v-spacer>
                <v-text-field type="date" v-model="startMonth" clearable label="From" @input="onUpdateFilters"></v-text-field>
              <v-spacer></v-spacer>
                <v-text-field type="date" v-model="endMonth" clearable label="To" @input="onUpdateFilters"></v-text-field>
              <v-spacer></v-spacer>
                <v-checkbox
                    v-model="errorMessageFilter"
                    label="only error"
                    @change="onUpdateFilters"
                ></v-checkbox>
              <v-spacer></v-spacer>
                <v-checkbox
                    v-model="deletedFilter"
                    label="not deleted"
                    @change="onUpdateFilters"
                ></v-checkbox>
              <v-spacer></v-spacer>
                <v-checkbox
                    v-model="uncheckedFilter"
                    label="only unchecked"
                    @change="onUpdateFilters"
                ></v-checkbox>
              <v-spacer></v-spacer>
                <v-checkbox
                    v-model="onlyActiveUser"
                    label="only active user"
                    @change="onUpdateFilters"
                ></v-checkbox>
            </v-row>
          </v-container>
        </v-toolbar>

      </template>
      <template v-slot:item.deleted="{ item }">
<!--        <span v-if="compareCurrentVsEventStart(item) || userId === null">-->
<!--          <v-checkbox v-model="item.deleted" @change="onChecked(item)"></v-checkbox>-->
<!--        </span>-->
<!--        <span v-else>-->
<!--          <v-simple-checkbox :value="item.deleted"></v-simple-checkbox>-->
<!--        </span>-->
        <BaseDeleteIcon
            v-model="item.deleted"
            :readonly="!(compareCurrentVsEventStart(item) || userId === null)"
            @input="onChecked(item)"
        ></BaseDeleteIcon>

      </template>
      <template v-slot:item.checked="{ item }">
        <span v-if="userId === null">
          <v-checkbox v-model="item.checked" @change="onChecked(item)"></v-checkbox>
        </span>
        <span v-else>
          <v-simple-checkbox :value="item.checked"></v-simple-checkbox>
        </span>
      </template>
      <template v-slot:item.event="{ item }">
        <v-chip dark :color="getEventColor(item)">
          <span class="font-weight-bold">{{ item.event }}</span>
        </v-chip>
      </template>
      <template v-slot:item.calendar_date_user__human_user__user="{ item }">
        <span v-if="item.calendar_date_user != null">
          {{ item.calendar_date_user.human_user.user }} ({{ item.calendar_date_user.human_user.employee_number }})
        </span>
      </template>
      <template v-slot:item.event_start="{ item }">
        <span v-if="item.event_start">
          {{ item.event_start | moment("DD.MM.YYYY HH:mm:ss") }}
        </span>
      </template>
      <template v-slot:item.event_start_time="{ item }">
        {{ item.event_start | moment("HH:mm:ss") }}
      </template>
      <template v-slot:item.event_stop="{ item }">
        <span v-if="item.event_stop && item.event_start !== item.event_stop">
          {{ item.event_stop | moment("DD.MM.YYYY HH:mm:ss") }}
        </span>
      </template>
      <template v-slot:item.event_stop_time="{ item }">
        <span v-if="item.event_stop && item.event_start != item.event_stop">{{ item.event_stop | moment("HH:mm:ss") }}</span>
      </template>
      <template v-slot:item.created_on="{ item }">
        <span v-if="item.created_on">{{ item.created_on | moment("DD.MM.YYYY HH:mm:ss") }}</span>
      </template>
      <template v-slot:item.edited_on="{ item }">
        <span v-if="item.edited_on">{{ item.edited_on | moment("DD.MM.YYYY HH:mm:ss") }}</span>
      </template>
      <template v-slot:item.created_by="{ item }">
        <span v-if="item.created_by">{{ item.created_by.username }}</span>
      </template>
      <template v-slot:item.edited_by="{ item }">
        <span v-if="item.edited_by">{{ item.edited_by.username }}</span>
      </template>
    </v-data-table>
    <TimeTrackerConfirmDialog></TimeTrackerConfirmDialog>
    <router-view></router-view>
  </v-container>
</template>

<script>
import {debounce} from "debounce"
import {mapGetters, mapActions} from 'vuex';
import {mapFields} from 'vuex-map-fields';
import TimeTrackerEnterEvent from "@/components/TimeTracker/TimeTrackerEnterEvent";
import BaseDeleteDialog from "@/components/BaseDeleteDialog";
import TimeTrackerNewDialogTime from "@/components/TimeTracker/TimeTrackerNewDialogTime";
import TimeTrackerNewDialogRange from "@/components/TimeTracker/TimeTrackerNewDialogRange";
import TimeTrackerConfirmDialog from "@/components/TimeTracker/TimeTrackerConfirmDialog";
import BaseDeleteIcon from "@/components/Base/BaseDeleteIcon";


export default {
  name: 'TimeTrackerEvent',
  props: {
    subtractHeight: {type: [Number], default: 290},
    height: {type: [Number], default: window.innerHeight},
    userId: {default: null},
    date: {default: null},
    dto_model: {type: [String], default: 'TimeTrackerEventDTO'},
    uncheckedInit: {type: [Boolean], default: null},
    deletedInit: {type: [Boolean], default: null},
    errorInit: {type: [Boolean], default: null},
  },

  components: {
    TimeTrackerEnterEvent,
    BaseDeleteDialog,
    TimeTrackerNewDialogTime,
    TimeTrackerNewDialogRange,
    TimeTrackerConfirmDialog,
    BaseDeleteIcon,
  },

  computed: {
    ...mapGetters('TimeTracker', ['getColumns']),
    ...mapFields('TimeTracker', ['message_error', 'options', 'totalRecords', 'options.page', 'onlyFailedView', 'briefView', 'itemList',
      'loading', 'deleteLoading', 'updateLoading', 'restoring', 'selectedItemList', 'searchTermFile', 'searchTerm',
      'isAlive', 'action_loading', 'filters', 'local_phrase']),
    ...mapFields('HumanUser', {itemListHuman: 'itemList'},),
  },
  watch: {
    date: function (newVal, oldVal) { // watch it
      // console.log('Prop changed: ', newVal, ' | was: ', oldVal)
      this.localFilterDate = newVal
      this.onUpdateFilters()
    },
  },

  methods: {
    ...mapActions('TimeTracker', ['openWebSocket', 'fetchItemList', 'fetchItem', 'fetchDeleteSelectedItem',
      'fetchSyncNotionSelectedItems', 'fetchRestoreSelectedItems', 'fetchSaveItemField', 'fetchOrderItemList',
      'fetchActionSelectedItem', 'fetchActionItem']),
    ...mapActions('HumanUser', {fetchItemListHuman: 'fetchItemList'}),

    onResize() {
      this.windowSize = { x: window.innerWidth, y: window.innerHeight };
    },

    itemRowBackground: function (item) {
      // console.log('row click', item)
      if (item.error_message != null)
        return "event_error"
      else
        return "event_" + item.event
    },

    getEventColor: function (item) {
      return this.local_phrase[item.event].color
    },

    onChecked(item) {
      // console.log('onChecked', item)
      this.fetchSaveItemField({
        itemId: item.id,
        fields_dict: {deleted: item.deleted, checked: item.checked},
        dto_model: {to_consumer: this.dto_model, from_consumer: this.dto_model}
      })
    },

    compareCurrentVsEventStart(item) {
      const currentDate = new Date()
      currentDate.setHours(0)
      currentDate.setMinutes(0)
      currentDate.setSeconds(0)
      currentDate.setMilliseconds(0)
      const event_start = new Date(item.event_start)
      return event_start.getTime() >= currentDate.getTime()
    },

    updateOptions() {
      // console.log('updateOptions', this.userId)
      this.fetchItemList({to_consumer: this.dto_model, from_consumer: this.dto_model})
    },

    onUpdateFilters() {
      // console.log('updateOptions', this.userId, this.filterEvents, this.startMonth, this.endMonth)
      this.options.page = 1

      this.filters = {}

      if (this.errorMessageFilter)
        this.filters['error_message'] = true
      else
        this.filters['error_message'] = null

      if (this.uncheckedFilter)
        this.filters['unchecked'] = false
      else
        this.filters['unchecked'] = null

      if (this.deletedFilter)
        this.filters['not_deleted'] = true
      else
        this.filters['not_deleted'] = null

      if (this.userId !== null)
        this.filters['user_id'] = this.userId

      if (this.filterEvents.length !== 0)
        this.filters['events'] = this.filterEvents
      else
        this.filters['events'] = []

      if (this.localFilterDate != null) {
        this.filters['date'] = this.localFilterDate
        this.filters['start_datetime'] = null
        this.filters['end_datetime'] = null
      }
      else {
        if (this.startMonth) {
          console.log('startMonth', this.startMonth)
          this.filters['start_datetime'] = this.startMonth + " 00:00:00"
        } else
          this.filters['start_datetime'] = null
        if (this.endMonth)
          this.filters['end_datetime'] = this.endMonth + " 23:59:59"
        else
          this.filters['end_datetime'] = null
      }

      if (this.onlyActiveUser === true)
        this.filters['only_active_user'] = true

      this.fetchItemList({to_consumer: this.dto_model, from_consumer: this.dto_model})
    },

    onRemoveItems() {
      this.fetchDeleteSelectedItem()
    },

    onUpdateSearchTerm: debounce(function () {
      // console.log('onUpdateSearchTerm', this.filters)
      this.options.page = 1
      this.fetchItemList({to_consumer: this.dto_model, from_consumer: this.dto_model})
    }, 800),

    statusColor() {
      if (this.search_status === 'OK')
        return 'success'
      if (this.search_status === 'NOK')
        return 'error'
      return 'primary'
    },
  },

  async mounted() {
    // console.log('mounted')
    this.briefView = this.userId != null
    window.addEventListener("resize", this.onResize)
    this.onResize()
    this.searchTerm = null
    if (this.uncheckedInit !== null) {
      this.uncheckedFilter = this.uncheckedInit
    }
    if (this.deletedInit !== null) {
      this.deletedFilter = this.deletedInit
    }
    if (this.deletedInit !== null) {
      this.errorMessageFilter = this.errorInit
    }
    this.onUpdateFilters()
    if (this.itemListHuman.length === 0)
      await this.fetchItemListHuman({to_consumer: 'HumanUserBaseDTO', from_consumer: 'HumanUserBaseDTO'})
  },

  created() {
    window.addEventListener("resize", this.onResize);
  },
  destroyed() {
    window.removeEventListener("resize", this.onResize);
  },

  beforeDestroy() {
  },

  data() {
    return {
      localFilterDate: this.date,
      windowSize: {x: 0, y: 0,},
      userSelected: null,
      filterEvents: [],
      eventsList: ['tracker', 'working', 'work_kug', 'pause', 'time_correction', 'HRPayed', 'holiday', 'holiday_extra', 'sick', 'sick_with_child', 'sick_kug'],
      errorMessageFilter: false,
      uncheckedFilter: false,
      deletedFilter: false,
      startMonth: null,
      endMonth: null,
      onlyActiveUser: true,
    }
  }
}
</script>

<style>
.row_even {
  background-color: white !important;
}

.event_working, .event_work_kug {
  background-color: #E3F2FD !important;
}

.event_time_correction {
  background-color: #E1F5FE !important;
}

.event_time_add {
  background-color: #E1F5FE !important;
}

.event_holiday, .event_holiday_extra {
  background-color: #E8F5E9 !important;
}

.event_sick, .event_sick_with_child, .event_sick_kug {
  background-color: #FFF8E1 !important;
}

.event_error {
  background-color: #FFEBEE !important;
}

</style>
